<template>
  <div class="home-page">
    <!-- 轮播图区域 -->
    <section class="relative">
      <div class="carousel overflow-hidden relative h-[400px] md:h-[500px] lg:h-[600px]">
        <div 
          class="carousel-inner flex transition-transform duration-500 ease-in-out"
          :style="{ transform: `translateX(-${currentSlide * 100}%)` }"
        >
          <div class="carousel-item w-full flex-shrink-0 h-full">
            <img 
              src="https://picsum.photos/1920/600?random=1" 
              alt="促销活动" 
              class="w-full h-full object-cover"
            >
            <div class="absolute top-1/2 left-10 md:left-20 transform -translate-y-1/2 text-white">
              <h2 class="text-[clamp(1.5rem,4vw,3rem)] font-bold mb-4 text-shadow">新品上市</h2>
              <p class="text-[clamp(1rem,2vw,1.5rem)] mb-6 max-w-md text-shadow">精选数码产品，限时8折优惠，开启智能生活新体验</p>
              <button class="bg-primary hover:bg-primary/90 text-white px-8 py-3 rounded-full font-medium transition-all">
                立即抢购
              </button>
            </div>
          </div>
          <div class="carousel-item w-full flex-shrink-0 h-full">
            <img 
              src="https://picsum.photos/1920/600?random=2" 
              alt="限时特惠" 
              class="w-full h-full object-cover"
            >
            <div class="absolute top-1/2 right-10 md:right-20 transform -translate-y-1/2 text-white text-right">
              <h2 class="text-[clamp(1.5rem,4vw,3rem)] font-bold mb-4 text-shadow">限时特惠</h2>
              <p class="text-[clamp(1rem,2vw,1.5rem)] mb-6 max-w-md ml-auto text-shadow">全场商品满299减50，满599减120，错过再等一年</p>
              <button class="bg-warning hover:bg-warning/90 text-white px-8 py-3 rounded-full font-medium transition-all">
                查看优惠
              </button>
            </div>
          </div>
          <div class="carousel-item w-full flex-shrink-0 h-full">
            <img 
              src="https://picsum.photos/1920/600?random=3" 
              alt="会员专享" 
              class="w-full h-full object-cover"
            >
            <div class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white text-center">
              <h2 class="text-[clamp(1.5rem,4vw,3rem)] font-bold mb-4 text-shadow">会员专享</h2>
              <p class="text-[clamp(1rem,2vw,1.5rem)] mb-6 max-w-md mx-auto text-shadow">会员购物额外95折，积分翻倍，专属客服一对一服务</p>
              <button class="bg-secondary hover:bg-secondary/90 text-white px-8 py-3 rounded-full font-medium transition-all">
                开通会员
              </button>
            </div>
          </div>
        </div>
        
        <!-- 轮播控制按钮 -->
        <button 
          class="absolute top-1/2 left-4 transform -translate-y-1/2 w-10 h-10 rounded-full bg-white/30 hover:bg-white/50 flex items-center justify-center text-white transition-all"
          @click="prevSlide"
        >
          <i class="fa fa-chevron-left text-xl"></i>
        </button>
        <button 
          class="absolute top-1/2 right-4 transform -translate-y-1/2 w-10 h-10 rounded-full bg-white/30 hover:bg-white/50 flex items-center justify-center text-white transition-all"
          @click="nextSlide"
        >
          <i class="fa fa-chevron-right text-xl"></i>
        </button>
        
        <!-- 轮播指示器 -->
        <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2">
          <button 
            v-for="(item, index) in 3" 
            :key="index"
            class="w-3 h-3 rounded-full transition-all"
            :class="index === currentSlide ? 'bg-white w-8' : 'bg-white/50'"
            @click="currentSlide = index"
          ></button>
        </div>
      </div>
    </section>

    <!-- 分类导航 -->
    <section class="py-12 bg-white">
      <div class="container mx-auto px-4">
        <h2 class="text-[clamp(1.25rem,3vw,2rem)] font-bold text-center mb-10">商品分类</h2>
        <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
          <div 
            v-for="(category, index) in categories" 
            :key="index"
            class="category-item text-center p-4 rounded-lg hover:shadow-elevation-2 transition-all cursor-pointer"
          >
            <!-- ✅ 修复：合并重复的 class 属性 -->
            <div class="w-16 h-16 mx-auto mb-3 bg-primary/10 rounded-full flex items-center justify-center">
              <i class="fa text-2xl text-primary" :class="category.icon"></i>
            </div>
            <h3 class="font-medium">{{ category.name }}</h3>
          </div>
        </div>
      </div>
    </section>

    <!-- 热门商品 -->
    <section class="py-12 bg-neutral-50">
      <div class="container mx-auto px-4">
        <div class="flex justify-between items-center mb-8">
          <h2 class="text-[clamp(1.25rem,3vw,2rem)] font-bold">热门商品</h2>
          <router-link to="/products" class="text-primary hover:underline flex items-center">
            查看全部 <i class="fa fa-angle-right ml-1"></i>
          </router-link>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          <div 
            v-for="(product, index) in hotProducts" 
            :key="index"
            class="product-card bg-white rounded-lg overflow-hidden shadow-elevation-1 hover:shadow-elevation-3 transition-all"
          >
            <div class="relative">
              <img 
                :src="product.image" 
                :alt="product.name" 
                class="w-full h-64 object-cover"
              >
              <span v-if="product.discount" class="absolute top-3 left-3 bg-danger text-white text-xs px-2 py-1 rounded">
                {{ product.discount }}
              </span>
              <button class="absolute top-3 right-3 w-8 h-8 rounded-full bg-white/80 hover:bg-white flex items-center justify-center text-neutral-600 hover:text-danger transition-all">
                <i class="fa fa-heart-o"></i>
              </button>
            </div>
            
            <div class="p-4">
              <h3 class="font-medium mb-2 line-clamp-1">{{ product.name }}</h3>
              <p class="text-sm text-neutral-500 mb-3 line-clamp-2">{{ product.desc }}</p>
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-primary font-bold text-lg">¥{{ product.price }}</span>
                  <span v-if="product.originalPrice" class="text-sm text-neutral-400 line-through ml-2">¥{{ product.originalPrice }}</span>
                </div>
                <button class="bg-primary/10 hover:bg-primary/20 text-primary w-10 h-10 rounded-full flex items-center justify-center transition-all">
                  <i class="fa fa-shopping-cart"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 限时抢购 -->
    <section class="py-12 bg-white">
      <div class="container mx-auto px-4">
        <div class="text-center mb-8">
          <h2 class="text-[clamp(1.25rem,3vw,2rem)] font-bold mb-2">限时抢购</h2>
          <p class="text-neutral-500">剩余时间：<span class="text-danger font-medium" id="countdown">01:59:45</span></p>
        </div>
        
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          <div 
            v-for="(flash, index) in flashSales" 
            :key="index"
            class="flash-card rounded-lg overflow-hidden shadow-elevation-1 hover:shadow-elevation-3 transition-all"
          >
            <div class="relative">
              <img 
                :src="flash.image" 
                :alt="flash.name" 
                class="w-full h-48 object-cover"
              >
            </div>
            <div class="p-3">
              <h3 class="font-medium text-sm mb-1 line-clamp-1">{{ flash.name }}</h3>
              <div class="flex justify-between items-center">
                <div>
                  <span class="text-danger font-bold">¥{{ flash.price }}</span>
                  <span class="text-xs text-neutral-400 line-through ml-1">¥{{ flash.originalPrice }}</span>
                </div>
                <button class="bg-danger hover:bg-danger/90 text-white text-xs px-2 py-1 rounded">
                  立即抢
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 品牌专区 -->
    <section class="py-12 bg-neutral-50">
      <div class="container mx-auto px-4">
        <h2 class="text-[clamp(1.25rem,3vw,2rem)] font-bold text-center mb-8">品牌专区</h2>
        <div class="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-8 gap-4">
          <div 
            v-for="(brand, index) in brands" 
            :key="index"
            class="brand-item bg-white p-4 rounded-lg flex items-center justify-center hover:shadow-elevation-2 transition-all"
          >
            <img 
              :src="brand.logo" 
              :alt="brand.name" 
              class="h-10 object-contain"
            >
          </div>
        </div>
      </div>
    </section>

    <!-- 客户评价 -->
    <section class="py-12 bg-white">
      <div class="container mx-auto px-4">
        <h2 class="text-[clamp(1.25rem,3vw,2rem)] font-bold text-center mb-8">客户评价</h2>
        <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div 
            v-for="(review, index) in reviews" 
            :key="index"
            class="review-card bg-neutral-50 rounded-lg p-6 hover:shadow-elevation-2 transition-all"
          >
            <div class="flex items-center mb-4">
              <img 
                :src="review.avatar" 
                :alt="review.name" 
                class="w-12 h-12 rounded-full mr-4"
              >
              <div>
                <h3 class="font-medium">{{ review.name }}</h3>
                <div class="flex text-warning text-sm mt-1">
                  <i class="fa fa-star" v-for="i in review.rating" :key="i"></i>
                  <i class="fa fa-star-o" v-for="i in 5 - review.rating" :key="i"></i>
                </div>
              </div>
            </div>
            <p class="text-neutral-600 italic mb-3">"{{ review.content }}"</p>
            <p class="text-sm text-neutral-500">{{ review.product }}</p>
          </div>
        </div>
      </div>
    </section>

    <!-- 订阅专区 -->
    <section class="py-16 bg-primary/10">
      <div class="container mx-auto px-4 text-center">
        <h2 class="text-[clamp(1.25rem,3vw,2rem)] font-bold mb-4">订阅我们</h2>
        <p class="text-neutral-600 mb-6 max-w-2xl mx-auto">订阅我们的邮件，第一时间获取最新优惠、新品上市和专属折扣信息</p>
        <div class="max-w-md mx-auto flex">
          <input 
            type="email" 
            placeholder="输入您的邮箱地址" 
            class="flex-grow px-4 py-3 rounded-l-lg border border-neutral-300 focus:outline-none focus:ring-2 focus:ring-primary/30 focus:border-primary"
          >
          <button class="bg-primary hover:bg-primary/90 text-white px-6 py-3 rounded-r-lg font-medium transition-all">
            订阅
          </button>
        </div>
        <p class="text-xs text-neutral-500 mt-4">
          我们尊重您的隐私，不会向第三方分享您的邮箱。您可以随时取消订阅。
        </p>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'Home',
  data() {
    return {
      // 轮播图当前索引
      currentSlide: 0,
      // 轮播图定时器
      carouselTimer: null,
      // 分类数据
      categories: [
        { name: '手机', icon: 'fa-mobile-phone' },
        { name: '电脑', icon: 'fa-laptop' },
        { name: '平板', icon: 'fa-tablet' },
        { name: '耳机', icon: 'fa-headphones' },
        { name: '相机', icon: 'fa-camera' },
        { name: '手表', icon: 'fa-clock-o' },
        { name: '配件', icon: 'fa-headset' },
        { name: '更多', icon: 'fa-ellipsis-h' }
      ],
      // 热门商品数据
      hotProducts: [
        {
          name: 'iPhone 15 Pro 256GB 原色钛金属',
          desc: 'A17 Pro芯片，4800万像素主摄，全天候显示',
          price: 8999,
          originalPrice: 9999,
          discount: '立减1000',
          image: 'https://picsum.photos/400/400?random=10'
        },
        {
          name: 'MacBook Pro 14英寸 M3 Pro芯片',
          desc: '14.2英寸Liquid视网膜XDR显示屏，18小时续航',
          price: 12999,
          originalPrice: 13999,
          discount: '9.3折',
          image: 'https://picsum.photos/400/400?random=11'
        },
        {
          name: 'AirPods Pro 第二代 搭配MagSafe充电盒',
          desc: '主动降噪，通透模式，空间音频，防水抗汗',
          price: 1799,
          originalPrice: 1999,
          discount: '限时优惠',
          image: 'https://picsum.photos/400/400?random=12'
        },
        {
          name: 'iPad Pro 11英寸 M4芯片 256GB',
          desc: 'Liquid视网膜显示屏，120Hz刷新率，USB-C接口',
          price: 6999,
          originalPrice: 7499,
          discount: '立减500',
          image: 'https://picsum.photos/400/400?random=13'
        }
      ],
      // 限时抢购数据
      flashSales: [
        {
          name: '无线蓝牙耳机',
          price: 199,
          originalPrice: 399,
          image: 'https://picsum.photos/300/300?random=20'
        },
        {
          name: '20W快充充电器',
          price: 29,
          originalPrice: 89,
          image: 'https://picsum.photos/300/300?random=21'
        },
        {
          name: '手机支架',
          price: 9.9,
          originalPrice: 29.9,
          image: 'https://picsum.photos/300/300?random=22'
        },
        {
          name: '钢化膜3片装',
          price: 15.9,
          originalPrice: 39.9,
          image: 'https://picsum.photos/300/300?random=23'
        },
        {
          name: '数据线2米',
          price: 12.9,
          originalPrice: 29.9,
          image: 'https://picsum.photos/300/300?random=24'
        }
      ],
      // 品牌数据
      brands: [
        { name: 'Apple', logo: 'https://picsum.photos/100/50?random=30' },
        { name: 'Samsung', logo: 'https://picsum.photos/100/50?random=31' },
        { name: 'Huawei', logo: 'https://picsum.photos/100/50?random=32' },
        { name: 'Xiaomi', logo: 'https://picsum.photos/100/50?random=33' },
        { name: 'OPPO', logo: 'https://picsum.photos/100/50?random=34' },
        { name: 'VIVO', logo: 'https://picsum.photos/100/50?random=35' },
        { name: 'OnePlus', logo: 'https://picsum.photos/100/50?random=36' },
        { name: 'Realme', logo: 'https://picsum.photos/100/50?random=37' }
      ],
      // 客户评价数据
      reviews: [
        {
          name: '张先生',
          avatar: 'https://picsum.photos/100/100?random=40',
          rating: 5,
          content: '产品质量非常好，物流也很快，客服态度也很好，下次还会再来购买！',
          product: '购买了 iPhone 15 Pro'
        },
        {
          name: '李女士',
          avatar: 'https://picsum.photos/100/100?random=41',
          rating: 4,
          content: '商品和描述的一致，使用体验很好，就是价格要是再优惠点就更好了。',
          product: '购买了 MacBook Pro'
        },
        {
          name: '王先生',
          avatar: 'https://picsum.photos/100/100?random=42',
          rating: 5,
          content: '已经是第三次购买了，产品质量有保障，售后服务也很到位，值得推荐！',
          product: '购买了 AirPods Pro'
        }
      ]
    }
  },
  methods: {
    // 上一张轮播图
    prevSlide() {
      this.currentSlide = this.currentSlide === 0 ? 2 : this.currentSlide - 1
    },
    // 下一张轮播图
    nextSlide() {
      this.currentSlide = this.currentSlide === 2 ? 0 : this.currentSlide + 1
    },
    // 倒计时功能
    updateCountdown() {
      const countdownEl = document.getElementById('countdown')
      if (!countdownEl) return
      
      const timeParts = countdownEl.textContent.split(':')
      let hours = parseInt(timeParts[0])
      let minutes = parseInt(timeParts[1])
      let seconds = parseInt(timeParts[2])
      
      seconds--
      if (seconds < 0) {
        seconds = 59
        minutes--
        if (minutes < 0) {
          minutes = 59
          hours--
          if (hours < 0) {
            hours = 0
            minutes = 0
            seconds = 0
          }
        }
      }
      
      // 补零
      const formattedHours = hours.toString().padStart(2, '0')
      const formattedMinutes = minutes.toString().padStart(2, '0')
      const formattedSeconds = seconds.toString().padStart(2, '0')
      
      countdownEl.textContent = `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
    }
  },
  mounted() {
    // 自动轮播
    this.carouselTimer = setInterval(() => {
      this.nextSlide()
    }, 5000)
    
    // 倒计时定时器
    setInterval(() => {
      this.updateCountdown()
    }, 1000)
  },
  beforeDestroy() {
    // 清除定时器
    if (this.carouselTimer) {
      clearInterval(this.carouselTimer)
    }
  }
}
</script>

<style scoped>
/* 通用样式 */
.text-shadow {
  text-shadow: 0 2px 4px rgba(0,0,0,0.5);
}

.line-clamp-1 {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 轮播图样式 */
.carousel {
  position: relative;
}

/* 分类项 hover 效果 */
.category-item:hover {
  transform: translateY(-5px);
}

/* 商品卡片 hover 效果 */
.product-card:hover {
  transform: translateY(-5px);
}

/* 限时抢购卡片 hover 效果 */
.flash-card:hover {
  transform: translateY(-5px);
}

/* 品牌项 hover 效果 */
.brand-item:hover {
  transform: scale(1.05);
}

/* 评价卡片 hover 效果 */
.review-card:hover {
  transform: translateY(-5px);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .carousel {
    height: 300px !important;
  }
  
  .product-card img {
    height: 48px;
  }
  
  .flash-card img {
    height: 36px;
  }
}

@media (max-width: 480px) {
  .carousel {
    height: 200px !important;
  }
  
  .category-item {
    p {
      font-size: 12px;
    }
  }
}
</style>